'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'link-horizontal';
var width = 576;
var height = 512;
var aliases = ["chain-horizontal"];
var unicode = 'e1cb';
var svgPathData = ['', 'M304 288c61.9 0 112-50.1 112-112S365.9 64 304 64L144 64C82.1 64 32 114.1 32 176 32 218.3 55.5 255.2 90.2 274.2 86.7 284.5 84 295.2 82.3 306.2 33.6 283 0 233.5 0 176 0 96.5 64.5 32 144 32l160 0c79.5 0 144 64.5 144 144S383.5 320 304 320l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0zm240 48c0-42.3-23.5-79.2-58.2-98.2 3.5-10.3 6.1-20.9 7.8-31.9 48.7 23.1 82.3 72.7 82.3 130.2 0 79.5-64.5 144-144 144l-160 0c-79.5 0-144-64.5-144-144s64.5-144 144-144l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-61.9 0-112 50.1-112 112s50.1 112 112 112l160 0c61.9 0 112-50.1 112-112z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLinkHorizontal = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;